import React from 'react';
import { Row, Col } from 'react-bootstrap';
import JobConfigView from './JobConfigView.react';
import LogView from './LogView.react';

import { ScenarioPropTypes, LogsPropTypes } from '../util/helpers/SharedPropTypes';

const ScenarioViewArtifactData = ({ scenario, logs }) => (
  <div className='scenario-artifact-data'>
    <Row>
      <Col sm={12}>
        <Row className='scenario-details'>
          <Col sm={6}>
            <article className='jobDetail'>
              <JobConfigView jobConfig={scenario.parameters} />
            </article>
          </Col>
          {
            logs.size > 0 &&
            <Col sm={6}>
              <label className='control-label' htmlFor='nothing'>Job Logs</label>
              <article className='scenario-logs jobDetail'>
                <LogView entries={logs} />
              </article>
            </Col>
          }
        </Row>
      </Col>
    </Row>
  </div>
);

ScenarioViewArtifactData.propTypes = {
  scenario: ScenarioPropTypes,
  logs: LogsPropTypes,
};

export default ScenarioViewArtifactData;
